import {Injectable} from '@angular/core';
import {AuthSession, AuthSignInPayload} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaAuthHttpService} from '../tisa-auth-http.service';
import {CrudService} from '@tisa-group/cdk';

@Injectable()
export class SignInService implements CrudService {
  constructor(readonly http: TisaAuthHttpService) {}

  signIn(body: AuthSignInPayload): Observable<AuthSession> {
    return this.http.post<AuthSession>('/sign_in', body);
  }
}
